<template>
    <div id="DmhStart">
        <div v-if="isSelectedViewLoading" class="d-flex justify-content-center">
          <b-spinner class="brand-primary"></b-spinner>
        </div>
        <div v-else>
            <div v-if="isProgressBarShown" class="progress-bar-container">
                <div class="progress-bar-outer w-100">
                    <div class="progress-bar-inner bg-brand-primary " :style="{ width: progressWidth + '%' }"></div>
                </div>
            </div>
            <div v-if="selectedView === 'journey'" class="dmh-start-container content-container">
                <h2 class="dmh-start-title brand-text">{{ currentQuestion.question_text ? currentQuestion.question_text : currentQuestion.sub_heading }}</h2>
                <p v-show="currentQuestion.question_text && currentQuestion.sub_heading" class="dmh-start-subheading brand-text">{{ currentQuestion.sub_heading }}</p>
            <div class="dmh-options-container">
                    <SingleSelectQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                        :answerQuestion="answerQuestion" v-if="currentQuestion.question_type === 'select'">
                    </SingleSelectQuestion>
                    <DateTimeQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                        v-if="currentQuestion.question_type === 'date_time'"></DateTimeQuestion>
                    <ConfirmQuestion :question="currentQuestion" :setAnswer="setAnswer"
                        v-if="currentQuestion.question_type === 'text'"></ConfirmQuestion>
                    <DmhLocation question="currentQuestion" :setAnswer="setAnswer"
                        v-if="currentQuestion.question_type === 'location_detection'" @skip="answerQuestion" />
                    <TextQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                        v-if="currentQuestion.question_type === 'confirm'"></TextQuestion>
                    <TextAreaQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                        v-if="isTextInputQuestion"></TextAreaQuestion>
                    <SliderQuestion :question="currentQuestion" :answer="currentAnswer" :setAnswer="setAnswer"
                        v-if="currentQuestion.question_type === 'slider'"></SliderQuestion>
                    <div class="d-flex justify-content-end align-items-center pt-5 mt-3 dmh-start-btn-container">
                        <b-button @click="previous(questionHistory)" variant="cta-outline" size="lg"
                            squared>Previous</b-button>
                        <b-button :disabled="currentAnswer === null || !allAnswersValid || isAnswerQuestionLoading" variant="cta" size="lg" squared
                            v-if="currentQuestion.question_type !== 'select'" @click="answerQuestion()">Continue</b-button>
                    </div>
                    <div class="warning-container" v-if="currentQuestion.lower_alert && !hideWarning">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="mb-0 pb-0"><i class="fas fa-exclamation-circle pr-2"></i>Important</h4>
                            </div>
                            <button class="border-0 bg-transparent p-0" @click="setHideWarning(true)">
                                <i class="fas fa-times clickable"></i>
                            </button>
                        </div>
                        <div v-html="currentQuestion.lower_alert.text"></div>
                    </div>
                </div>

            </div>
            <div v-else-if="selectedView === 'TmhJourney'" class="dmh-start-container content-container">
              <TmhJourney :previous="getQuestion" :questionHistory="questionHistory" @nextTMHQuestion="reduceStepsToComplete" @previousTMHQuestion="increaseStepsToComplete" @proceedToCORE10="addStepsToComplete"/>
            </div>
            <div v-else-if="selectedView === 'booking'" class="dmh-options-container content-container">
                <DmhBooking :reset="reset" :previous="getQuestion" :questionHistory="questionHistory"></DmhBooking>
            </div>
            <div v-else-if="selectedView === 'financeComplete'" class="dmh-options-container content-container">
                <div class="d-flex flex-column align-items-center justify-content-center dmh-complete-container">
                    <h3>Thank you!</h3>
                    <p>Our Team will be in touch within 48 hours to confirm your appointment.</p>
                    <b-button variant="cta" size="lg" @click="$router.push('/')">Return to 'My Health'</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import config from "../config/constants";
import SingleSelectQuestion from "@/components/DMH/SingleSelectQuestion"
import TextQuestion from "@/components/DMH/TextQuestion"
import TextAreaQuestion from "@/components/DMH/TextAreaQuestion"
import ConfirmQuestion from "@/components/DMH/ConfirmQuestion"
import SliderQuestion from "@/components/DMH/SliderQuestion"
import DateTimeQuestion from "@/components/DMH/DateTimeQuestion"
import DmhBooking from "@/components/DMH/DmhBooking"
import EventBus from "@/helpers/eventbus"


import { mapGetters, mapState } from "vuex";
import DmhLocation from "@/components/DMH/Location.vue";
import TmhJourney from "../components/TMH/TmhJourney.vue";
import SHPhoneNumbers from "../components/DMH/SHPhoneNumbers.vue";

export default {
    name: "DmhStart",
    components: {
        DmhLocation,
        SingleSelectQuestion,
        TextQuestion,
        ConfirmQuestion,
        TextAreaQuestion,
        SliderQuestion,
        DateTimeQuestion,
        DmhBooking,
        TmhJourney,
        SHPhoneNumbers
    },
    data() {
        return {
            selectedView: 'journey',
            isSelectedViewLoading: false,
            selectedOptionQId: null,
            selectedOptionIndex: null,
            currentQuestion: null,
            currentAnswer: null,
            questionHistory: [],
            progressWidth: 0,
            hideWarning: false,
            totalNumberOfQuestions: null,
            numberOfQuestionsToComplete: null,
            isTmhJourney: null,
            isProgressBarShown: true,
            isAnswerQuestionLoading: false,
        };
    },
    mounted() {
        if (this.handoverPage) {
          this.getQuestion();
        } else {
          this.$router.push("/")
        }
        EventBus.$on('hideProgressBar', this.hideProgressBar);
    },
    methods: {
        reset() {
            this.selectedOptionIndex = null;
            this.selectedOptionQId = null;
            this.currentQuestion = null;
            this.questionHistory = [];
            this.currentAnswer = null;
            this.selectedView = 'journey';
            totalNumberOfQuestions = null;
            numberOfQuestionsToComplete = null;
            this.progressWidth = 0;
            this.scrollToRef();
            this.$router.push("/")
        },
        hideProgressBar() {
          this.isProgressBarShown = false
        },
        initChat() {
            let sf = document.getElementById('live-chat-widget');
            if (sf) {
                sf.style.display = "initial";
            } else {
                let script = document.createElement('script');
                script.src = "/assets/salesforce_Script.js";
                script.type = "text/javascript";
                script.charset = "UFT-8";
                script.setAttribute("id", "sf-script")
                document.head.appendChild(script);
            }
        },
        previous(questionHistory){
            if(questionHistory.length === 0){
                history.back();
            }else{
                this.getQuestion(questionHistory)
            }
        },
        setHideWarning(value){
            this.hideWarning = value;
        },
        reduceStepsToComplete() {
          this.numberOfQuestionsToComplete -= 1
        },
        increaseStepsToComplete() {
          this.numberOfQuestionsToComplete += 1
        },
        addStepsToComplete(num) {
          this.numberOfQuestionsToComplete += num
          this.totalNumberOfQuestions += num
        },
        async getQuestion(questionHistory, questionId) {
          try {
            let question_id;
            this.isSelectedViewLoading = true
            if (questionHistory?.length === 0) {
                this.selectedOptionQId = null;
                this.selectedOptionIndex = null;
                this.selectedView = 'journey';
                EventBus.$emit('updateNav', 'mh');
            } else if (questionHistory?.length > 0) {
                this.selectedView = 'journey'
            }
            if (questionHistory) {
                question_id = questionHistory.pop();
            }
            if (questionId) {
                if (questionId === this.totalNumberOfQuestions) {
                    EventBus.$emit('updateNav', 'finance');
                } else {
                    EventBus.$emit('updateNav', 'mh');
                }
                if (questionId === 'faq') {
                    return this.$router.push('/faqs')
                }
                if (questionId === 'articles') {
                    return this.$router.push('/articles')
                }
                question_id = questionId;
            }
            const payload = {
                user_id: this.$store.getters.user_id,
                question_id,
                service_type: this.handoverPage?.service_type,
                sdk_type: 'SH',
                sdk_version: '1.2.4'
            }
            let res = await axios.post(config.api_env + '/application/api/u/dmh/get-question', payload, config.options)
            if (res.data.success) {
                this.currentQuestion = res.data.question
                this.totalNumberOfQuestions = res.data.questionnaire_stage.total_number_of_questions
                this.numberOfQuestionsToComplete = res.data.questionnaire_stage.number_of_questions_to_complete
                this.isTmhJourney = res.data.questionnaire_name === "tmh"
                if (this.isTmhJourney) {
                  this.addStepsToComplete(5)
                }
                if (questionId) {
                    this.selectedView = 'journey'
                }
                if (['location_detection'].includes(res.data.question?.question_type)) {
                    this.currentAnswer = true
                } else if (res.data.question?.question_type === 'confirm') {
                    let answer = {};
                    res.data.question.options.forEach((o) => {
                        answer[o.field_key] = o.data
                    });
                    this.currentAnswer = answer;
                } else if (res.data.question?.question_type === 'slider') {
                    let answer = {};
                    res.data.question.sliders.forEach((s) => {
                        answer[s.slider_text] = s.options[2];
                    });
                    this.currentAnswer = answer;
                } else {
                    this.currentAnswer = null;
                }
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.$store.dispatch("logout");
                this.$router.push("/login").catch((err) => { });
            }
          } catch(err) {
            console.error(err)
          } finally {
            this.isSelectedViewLoading = false
          }
        },
        async answerQuestion() {
            this.isAnswerQuestionLoading = true
            const payload = {
                user_id: this.$store.getters.user_id,
                answered_question_id: this.currentQuestion.question_id,
                answer: this.currentAnswer,
                service_type: this.handoverPage?.service_type,
                sdk_type: 'SH',
                sdk_version: '1.2.4'
            }
            let res = await axios.post(config.api_env + '/application/api/u/dmh/answer-question', payload, config.options)
            this.isAnswerQuestionLoading = false
            if (res.data.success) {
                this.hideWarning = false;
                this.questionHistory.push(this.currentQuestion.question_id);
                if (this.isTmhJourney) {
                  this.totalNumberOfQuestions = res.data.questionnaire_stage.total_number_of_questions + 5
                  this.numberOfQuestionsToComplete -= 1
                } else {
                  this.numberOfQuestionsToComplete = res.data.questionnaire_stage.number_of_questions_to_complete
                  this.totalNumberOfQuestions = res.data.questionnaire_stage.total_number_of_questions
                }
                if (res.data.question === null) {
                    if(this.handoverPage?.service_type === 'legal'){
                        this.progressWidth = 100
                        this.selectedView = 'financeComplete'
                    } else if (this.isTmhJourney){
                        this.selectedView = 'TmhJourney';
                    } else {
                      this.selectedView = 'booking';
                    }
                } else {
                    this.currentQuestion = res.data.question;
                }
                if (['location_detection', 'text'].includes(res.data.question?.question_type)) {
                    this.currentAnswer = true
                } else if (res.data.question?.question_type === 'confirm') {
                    let answer = {};
                    res.data.question.options.forEach((o) => {
                        answer[o.field_key] = o.data
                    });
                    this.currentAnswer = answer;
                } else if (res.data.question?.question_type === 'slider') {
                    let answer = {};
                    res.data.question.sliders.forEach((s) => {
                        answer[s.slider_text] = s.options[2];
                    });
                    this.currentAnswer = answer;
                } else {
                    this.currentAnswer = null;
                }
                this.scrollToRef();
            } else if (res.data.err && res.data.err.includes("3994")) {
                this.$store.dispatch("logout");
                this.$router.push("/login").catch((err) => { });
            }
        },
        setAnswer(answer, type) {
            this.currentAnswer = answer;
        },
        getClass(text) {
            switch (text) {
                case "I'd like to talk to someone about my mental health.":
                    return "fa-solid fa-head-side-virus";
                case "I'd like to learn more about the service.":
                    return "fa-solid fa-book-open-reader";
                case "I'd like to learn more about mental health and wellbeing.":
                    return "fa-solid fa-heart-pulse";
                case "I'd like to get access another service like financial or legal.":
                    return "fa-solid fa-coins";
                case "Video":
                    return "fa-solid fa-video";
                case "Voice Only":
                    return "fa-solid fa-microphone";
                default:
                    return ""
            }
        },
    },
    computed: {
        isTextInputQuestion() {
            return this.currentQuestion?.question_type === 'text_input' || this.currentQuestion?.question_type === 'text_area'
        },
        allAnswersValid() {
            if (this.currentQuestion?.question_type === 'location_detection') return true;
            if (this.isTextInputQuestion) {
                return this.currentAnswer?.length > 4;
            }
            const validationResults = this.validateDmhAnswers(this.currentAnswer);
            return validationResults ? Object.values(validationResults).every(value => value === true) : true;
        },
        ...mapGetters(["user"]),
        ...mapState(['handoverPage']),
    },
    watch: {
        numberOfQuestionsToComplete(value) {
          let bookClinicianStep = 1
          if (this.isTmhJourney) {
            bookClinicianStep = 2
          }
          const totalSteps = this.totalNumberOfQuestions + bookClinicianStep
          const stepsToComplete = value + bookClinicianStep;
          this.progressWidth = ((totalSteps - stepsToComplete) / (totalSteps)) * 100;
        },
    },
};
</script>
<style lang="less">
#DmhStart {
    padding: 70px 0;
    min-height: 100%;
    background-color: #fff;

    .progress-bar-container {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 800px;
        padding: 0 20px;
        margin: 0 auto;

        .progress-bar-outer {
            max-width: 650px;
            background-color: #DBDBDB;
            height: 6px;
            border-radius: 5px;
            margin-bottom: 40px;
            overflow: hidden;

            .progress-bar-inner {
                border-radius: 6px;
                height: 100%;
            }
        }
    }

    .dmh-start-btn-container {
        gap: 24px;
    }

    .dmh-start-container {
        max-width: 650px;
        margin: 0 auto;
        .warning-container{
            border-radius: 16px;
            margin-top: 20px;
            background-color: #ffee99;
            font-size: 1.6rem;
            padding: 25px;
            h4{
                font-size: 1.8rem;
            }
            .fa-times{
                width: 48px;
                height: 48px;
                background-color: transparent !important;
                padding: 14px 18px;
                border-radius: 8px;
            }
        }
        .prompt-container {
            margin-top: 20px;
            padding: 25px;
            width: 100%;
            border-radius: 16px;
            background-color: white;
        }

        .dmh-start-title {
            width: 100%;
            text-align: left;
            font-size: 2.2rem;
            letter-spacing: 0;
            font-family: "PlusJakartaSansBold";
        }

        .dmh-start-subheading {
            align-self: flex-start;
            font-size: 1.8rem;
            margin-bottom: 32px;
        }

        .dmh-options-container {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            width: 100%;
        }

    }

    .dmh-complete-container {
        font-size: 1.8rem;

        h3 {
            text-align: center;
            font-size: 3.8rem;
            letter-spacing: 0;
            font-family: "PlusJakartaSansBold";
        }

        p {
            padding-bottom: 30px;
            max-width: 450px;
            text-align: center;
        }
    }

    @media only screen and (max-width: 576px) {
      .dmh-start-btn-container {
          gap: 16px;
      }
    }
}
</style>